const Building = ({ stroke = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      d="M2.5 14V3.5h7V14M9.5 14V7h4v7M2.5 14h11M4.5 6h1M6.5 6h1M4.5 8.5h1M6.5 8.5h1M4.5 11h1M6.5 11h1M11 9.5h1M11 12h1"
      stroke={stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Building;
